import { useNavigate } from "react-router-dom";
import { Dropdown } from "primereact/dropdown";
import { useAuth } from "../../context/AuthContext";

export default function PageHeader({ rightContent = true }) {
    const navigate = useNavigate();
    const { user, customerList, switchCustomer } = useAuth();
    return (
        <section className="customer-selection">
            {rightContent && (
                <div className="product-detail-header-right">
                    <Dropdown
                        value={customerList.find(c => c.Customer_ID === user.SelectedCustomer_ID) || null}
                        options={customerList}
                        onChange={(e) => {
                            switchCustomer(e.value);
                            window.location.reload(); 
                        }}
                        optionLabel="FirstName"
                        placeholder="Select Customer"
                        className="Cutomer-list"
                        filter
                        filterBy="FirstName"
                        emptyFilterMessage="No customer found"
                        itemTemplate={(item) => <div>{item.FirstName}</div>}
                    />
                </div>
            )}
        </section>
    );
}